import React from 'react';
import './landing.css';
import CTA from './CTA';
import LandingSocials from './LandingSocials';
import Portrait from '../../images/portrait.png';

function Landing() {
    return(
        <div className="container landing__container">
            <h5 className='blueh5'>hello, I'm...</h5>
            <h1>Marwan</h1>
            <h5 className='text-light'>Software Engineer, Video Producer</h5>
            <CTA />
            <div className='me'>
                <div className='fillerImage'>
                    <img src={Portrait}></img>
                </div>
                <a href='#contact' className='scroll__down'>Scroll Down</a>
            </div>
            <LandingSocials/>
        </div>
    )
}

export default Landing;